import {
  Skeleton,
  SkeletonButton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from '../SkeletonComponents';

/**
 * Skeleton for the Settlements tab CONTENT ONLY
 * Used within GroupPageLayout - no header or tabs included
 * Matches: GroupSettlementsPage settlements container
 */
export function SettlementsContentSkeleton() {
  return (
    <div data-testid="settlements-skeleton">
      {/* Header with Action Buttons - matches GroupSettlementsPage */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          {/* Create Settlement button */}
          <SkeletonButton className="w-full sm:w-44 h-10" />
          {/* Record Payment button */}
          <SkeletonButton className="w-full sm:w-40 h-10" />
        </div>
        {/* Filter Toggle Button */}
        <SkeletonButton className="w-full sm:w-28 h-9" />
      </div>

      {/* Settlements List */}
      <div className="space-y-3">
        {[1, 2, 3, 4].map(i => (
          <SkeletonCard key={i} className="p-4 sm:p-6">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
                  <div className="flex-1">
                    {/* "You paid..." text */}
                    <SkeletonText className="w-48 h-5 mb-1" />
                  </div>
                  {/* Status badge */}
                  <div className="self-start sm:ml-3">
                    <Skeleton className="w-24 h-6 rounded-full" />
                  </div>
                </div>
                {/* Amount */}
                <SkeletonTitle className="w-32 h-8 mb-1" />
                {/* Date */}
                <SkeletonText className="w-28 h-4 mt-1" />
                {/* Notes (optional) */}
                {i % 2 === 0 && <SkeletonText className="w-64 h-4 mt-2" />}
              </div>

              {/* Action buttons (show for some cards - pending status) */}
              {i <= 2 && (
                <div className="flex flex-row sm:flex-col gap-2 sm:gap-1.5 w-full sm:w-auto sm:min-w-[140px]">
                  <SkeletonButton className="flex-1 sm:flex-initial w-full min-h-[40px]" />
                  <SkeletonButton className="flex-1 sm:flex-initial w-full min-h-[40px]" />
                </div>
              )}
            </div>
          </SkeletonCard>
        ))}
      </div>
    </div>
  );
}

/**
 * Full page skeleton for Settlements page (standalone use)
 * @deprecated Use SettlementsContentSkeleton with GroupPageLayout instead
 */
export function SettlementsPageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      <SettlementsContentSkeleton />
    </div>
  );
}
